import IQualite from '@/types/qualite.interface';
import http from './api.service';

class QualiteService {
    getPrice(qualite: IQualite) {
        return http.post('/qualite/getprice', qualite,
            {
                headers: {'Content-Type': 'application/json'}
            })
    }

    order(qualite: IQualite, user, basket) {
        return http.post('/qualite/order', {...qualite, basket: {...basket, ...{email: user.email}}},
            {
                headers: {'Content-Type': 'application/json'},
                params: {userId: user.id}
            })
    }

    preview(qualite: IQualite, user) {
        return http.post('/qualite/preview', qualite,
            {
                headers: {'Content-Type': 'application/json'},
                params: {userId: user.id}
            })
    }
}

export default new QualiteService();